// src/field-datepicker.js
import { __ } from '@wordpress/i18n';

import debug from './isDebug.js'

const SaphaliDateTimePicker = React.memo(({ fieldIds, onDateChange, type_field }) => {
  if (debug) console.log('fieldIds', fieldIds);
  const initializeDateTimePickerForField = (selector, type_field) => {    
    const $field = jQuery(selector);
    if (!$field.length) {console.log(`Field not found: ${selector}`);
     return;}
    if (debug) console.log("Initializing DateTimePicker for:", selector, type_field);
    if (type_field === 'onlydate') {
      if (!$field.hasClass("has-datepicker")) {
        $field.datepicker({
          dateFormat: "dd.mm.yy",
          minDate: 0,
          firstDay: 1,
          onSelect: function(dateText, inst) {
            const value = jQuery(this).val();
            if (typeof onDateChange === 'function') {
              ['billing', 'shipping', 'additional-information', 'contact'].forEach(v => {
                if (selector.indexOf(`#${v}`) === 0 ) {
                  const c_selector = selector.replace(`#${v}-`, '').replace('saphali-', 'saphali/');
                  onDateChange(c_selector, value, v);
                } else if (selector.indexOf(`[id="${v}-`) > 0 ) {
                  const c_selector = selector.replace(new RegExp(`.*\\[id="${v}-`), '').replace('"]', '').replace('saphali-', 'saphali/');                  
                  onDateChange(c_selector, value, v);
                }
              });
            }
          },
        });
        $field.addClass("has-datepicker");
        if (debug) console.log(`DatePicker initialized for ${selector}`);
      }
    } else {
      if (!$field.hasClass("has-datetimepicker")) {
        $field.datetimepicker({
          dateFormat: "dd.mm.yy",
          timeFormat: "HH:mm",
          minDate: 0,
          stepMinute: 15,
          closeText: __('Done', 'saphali-woocommerce-lite'),
          currentText: __('Now', 'saphali-woocommerce-lite'),
          timeText: __('Time', 'saphali-woocommerce-lite'),
          hourText: __('Hour', 'saphali-woocommerce-lite'),
          minuteText: __('Minute', 'saphali-woocommerce-lite'),
          timeOnlyTitle: __('Choose Time', 'saphali-woocommerce-lite'),
          firstDay: 1,
          controlType: 'select',
          oneLine: true,
          onSelect: function(datetimeText, inst) {
            const value = jQuery(this).val();
            if (typeof onDateChange === 'function') {
              ['billing', 'shipping', 'additional-information', 'contact'].forEach(v => {
                if (selector.indexOf(`#${v}`) === 0) {
                  const c_selector = selector.replace(`#${v}-`, '').replace('saphali-', 'saphali/');
                  onDateChange(c_selector, value, v);
                } else if (selector.indexOf(`[id="${v}-`) > 0 ) {
                  const c_selector = selector.replace(new RegExp(`.*\\[id="${v}-`), '').replace('"]', '').replace('saphali-', 'saphali/');                  
                  onDateChange(c_selector, value, v);
                }
              });
            }
          },
        });
        $field.addClass("has-datetimepicker");
        if (debug) console.log(`DateTimePicker initialized for ${selector}`);
      }
    }
  };
  React.useEffect(() => {
    
    if (fieldIds && Array.isArray(fieldIds)) {
      fieldIds.forEach(fieldId => {
        const selector = `${fieldId}`;
        initializeDateTimePickerForField(selector, type_field);
      });
    }
  }, [fieldIds, type_field]);

  return null;
});

export default SaphaliDateTimePicker;
